import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { RequestService } from '../../../../services/request.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Lightbox } from 'ngx-lightbox';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { FilterStoreService } from '../../../../services/filter-store.service';
import {
  PAGE_SIZE_OPTIONS,
  PageIndexService,
} from '../../../../services/page-index-service';
import { FilterEnabledComponent } from '../../../../helpers/filter-enabled.component';
import { Project } from '../../../../model/project/project';
import { SendThankYouMailComponent } from '../../../../modals/send-thank-you-mail/send-thank-you-mail.component';
import {
  catchError,
  debounceTime,
  map,
  startWith,
  switchMap,
} from 'rxjs/operators';
import { merge, of as observableOf, Subject } from 'rxjs';
import ProductHelper from '../../../../helpers/product-helper';
import Product from '../../../../model/product/product';
import Employee from '../../../../model/product/employee';
import { User } from '../../../../model/user';
import ProjectHelper from '../../../../helpers/project-helper';
import { QuotationSitevisitPendingComponent } from '../../../../modals/quotation-sitevisit-pending/quotation-sitevisit-pending.component';
import { SubProject } from '../../../../model/project/sub-project';
import { StringHelper } from 'src/app/helpers/string-helper';
import { ModalService } from '../../../../services/modal.service';
import DateHelper from '../../../../helpers/date-helper';
import * as moment from 'moment-timezone';
import Windowsticker from '../../../../model/product/windowsticker/windowsticker';
import { Adjustment } from '../../../../model/project/adjustment';
import { AuthService } from '../../../../services/auth.service';
import { ClientCompanySelectService } from '../../../../services/client-company-select.service';
import { ProductTypeCriteriumService } from 'src/app/services/product-type-criterium-service';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { PrintAddressPipe } from 'src/app/pipes/print-address.pipe';
import Asset from 'src/app/model/asset';
import { SnackService } from 'src/app/services/snack.service';
import { NotificationMailComponent } from 'src/app/modals/notification-mail/notification-mail.component';
import { LocationVerificationDialogComponent } from 'src/app/modals/location-verification-dialog/location-verification-dialog.component';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { ScrollTopService } from 'src/app/services/scroll-top.service';
import ProductAsset from 'src/app/model/product-asset';

@Component({
  selector: 'app-projects-table',
  templateUrl: './projects-table.component.html',
  styleUrls: ['./projects-table.component.scss'],
  providers: [PrintAddressPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsTableComponent
  extends FilterEnabledComponent
  implements OnInit, OnDestroy
{
  @Output()
  reloadCountChange = new EventEmitter<any>();

  projects: SubProject[];

  rendered: SubProject[];
  renderedStream: Subject<SubProject[]> = new Subject();

  totalItems = 0;
  chunkSize = 5;
  rendering = false;

  routerLinkOpen: string;

  pageSizeOptions = PAGE_SIZE_OPTIONS;
  reloadData: EventEmitter<any>;
  data: Project[] = [];
  private dialogRef: MatDialogRef<SendThankYouMailComponent>;
  private dialogModalRef: MatDialogRef<QuotationSitevisitPendingComponent>;
  private locationVerificationDialogRef: MatDialogRef<LocationVerificationDialogComponent>;
  displayedColumns: string[] = [];
  loading = false;
  private momentToday = moment();

  currentConfirmedPlacementDateLabel: string;
  subProjectTypeRightMargin = false;

  newProjectLabel = 'Nieuw project';
  fixedSubProjectTypeLabel = null;
  fixedSubProjectTypeClass = null;

  assignPlanningId: number;
  assignOpen: boolean = false;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private modalService: ModalService,
    private router: Router,
    private datepipe: DatePipe,
    private _lightbox: Lightbox,
    private dialog: MatDialog,
    protected requestService: RequestService,
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService,
    protected authService: AuthService,
    protected productTypeCriteriumService: ProductTypeCriteriumService,
    protected clientCompanySelectService: ClientCompanySelectService, //TODO only needed in client corner, put this lower down the hierarchy later
    protected snackService: SnackService,
    protected scrollTopService: ScrollTopService,
    protected cd: ChangeDetectorRef
  ) {
    super(
      [
        {
          key: 'project__id',
          active: false,
          strictEquality: true,
          numeric: true,
        },
        {
          key: 'projectPlacement__address',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'project__projectContacts__company__name',
          active: false,
          strictEquality: false,
          numeric: false,
        },
        {
          key: 'status',
          active: false,
          strictEquality: false,
          numeric: false,
        },
        {
          key: 'createdAt',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'currentCreatedAt',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'currentRequestDate',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'quotationByDate',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'currentDesignDate',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'currentPrintDate',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'currentFinishDate',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'currentSiteVisitDate',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'currentExecutionDate',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'project__products__materialDisplayName',
          active: false,
          strictEquality: false,
          numeric: false,
        },
        {
          key: 'placers__project',
          active: false,
          strictEquality: false,
          numeric: false,
        },
        {
          key: 'designers__project',
          active: false,
          strictEquality: false,
          numeric: false,
        },
        {
          key: 'printworkHandlers__project',
          active: false,
          strictEquality: false,
          numeric: false,
        },
        {
          key: 'finishers__project',
          active: false,
          strictEquality: false,
          numeric: false,
        },
        {
          key: 'quotationHandler__user__name',
          active: false,
          strictEquality: false,
          numeric: false,
        },
      ],
      filterStoreService,
      pageIndexService
    );
    this.projects = [];
    this.rendered = [];
  }

  ngOnInit() {
    this.loading = true;
    this.routerLinkOpen = '/project';
    this.prepareCurrentConfirmedPlacementDateLabel();
    this.reloadData = new EventEmitter<any>();

    this.paginator.pageIndex = this.initPageIndex;
    this.paginator.pageSize = this.initPageSize;

    this.sort.sort({
      id: this.getDefaultSort(),
      start: this.getDefaultSortDirection(),
      disableClear: true,
    } as MatSortable);

    this.sort.sortChange.subscribe(() => {
      this.pageIndexService.setPageIndex(this.getLocalStorageKey(), 0);
      this.paginator.pageIndex = 0;
    });

    this.filtersChanged.pipe(debounceTime(800)).subscribe(() => {
      this.pageIndexService.setPageIndex(this.getLocalStorageKey(), 0);
      this.paginator.pageIndex = 0;
      this.reloadData.emit();
    });

    merge(this.sort.sortChange, this.paginator.page, this.reloadData)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.loading = true;
          window.scrollTo(0, 0);
          this.pageIndexService.setPageIndex(
            this.getLocalStorageKey(),
            this.paginator.pageIndex
          );
          this.pageIndexService.setPageSize(
            this.getLocalStorageKey(),
            this.paginator.pageSize
          );
          this.cd.markForCheck();
          return this.requestService.get(
            this.getTableUrl(),
            this.generateTypeCriteriumParam(),
            this.sort.active,
            this.sort.direction,
            this.paginator.pageSize,
            this.paginator.pageIndex,
            this.generateFilterString()
          );
        }),
        map((data) => {
          this.totalItems = Number.parseInt(data.headers.get('X-Total-Count'));
          return data.body;
        }),
        catchError(() => {
          return observableOf([]);
        })
      )
      .subscribe((data) => {
        this.preProcessProjects(data);
        this.projects = data;
        this.loading = false;
        if (data == null || data.length === 0) {
          if (this.paginator.pageIndex > 0) {
            this.paginator.pageIndex = 0;
            this.reloadData.next();
          } else {
            this.startRendering();
          }
        } else {
          this.startRendering();
        }
      });

    this.addSubscription(
      this.productTypeCriteriumService.getTypeCriteriumChangedSubscribable(),
      (selectedTypeOptions) => {
        this.reloadData.next();
      }
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.renderedStream.complete();
  }

  ngAfterContentChecked() {
    if (this.rendering) {
      this.renderNextChunk();
    }
  }

  startRendering() {
    if (!this.rendering) {
      this.rendered.length = 0;
      this.rendering = true;
      this.cd.markForCheck();
    }
  }

  renderNextChunk() {
    if (this.rendered.length >= this.projects.length) {
      if (this.projects.length === 0) {
        this.rendered.length = 0;
        this.renderedStream.next(this.rendered);
      }
      this.rendering = false;
      return;
    }

    this.rendered = [
      ...this.rendered,
      ...this.projects.slice(
        this.rendered.length,
        Math.min(this.projects.length, this.rendered.length + this.chunkSize)
      ),
    ];
    this.renderedStream.next(this.rendered);
    // TODO: apparently using setTimeout in this manner triggers global change detection
    // This doesn't seem particularly problematic at the moment, but a more elegant solution has yet to be found
    setTimeout(() => {
      this.cd.detectChanges();
    }, 0);
  }

  deleteProject(project) {
    this.modalService.confirmDialog(
      'Project verwijderen',
      this.getDeleteConfirmText(project),
      (answer) => {
        if (answer) {
          this.addSubscription(
            this.requestService.delete('/subprojects/archive/' + project.id),
            () => {
              this.reloadData.next();
              this.reloadCountChange.emit();
            }
          );
        }
      }
    );
  }

  getDeleteConfirmText(subproject) {
    return subproject.project != null &&
      subproject.project.someSubProjectsInProgress
      ? 'Bent u zeker dat u dit project wilt verwijderen? WAARSCHUWING: Er zijn nog lopende zaken voor dit project.'
      : 'Bent u zeker dat u dit project wilt verwijderen?';
  }

  translateType(type: string, otherProductName: string) {
    return ProductHelper.getAbbreviatedType(type, otherProductName);
  }

  getTypeTooltip(type: string, otherProductName) {
    return ProductHelper.getType(type, otherProductName);
  }

  formatDate(date: Date) {
    return this.datepipe.transform(date, 'dd/MM/yyyy');
  }

  getFormat(product: Product) {
    if (!ProductHelper.isWindowSticker(product)) {
      return '';
    }
    const standardStickerParts = (<Windowsticker>product).standardStickerParts;
    if (!CollectionHelper.isPopulated(standardStickerParts)) {
      return '';
    }
    const standardStickerPart = standardStickerParts[0];
    if (standardStickerPart.productSize != null) {
      return (
        standardStickerPart.productSize.height +
        ' x ' +
        standardStickerPart.productSize.width +
        ' cm'
      );
    } else if (standardStickerPart.requestedProductSize != null) {
      return (
        standardStickerPart.requestedProductSize.height +
        ' x ' +
        standardStickerPart.requestedProductSize.width +
        ' cm'
      );
    } else {
      return '';
    }
  }

  getCurrentExecutionDate(project: SubProject) {
    return ProjectHelper.getCurrentExecutionDate(project);
  }

  openlightbox(product: Product) {
    let albums = [];
    for (let productAsset of product.productAssets) {
      if (productAsset.archived) {
        continue;
      }
      const src = '/api/assets/' + productAsset.asset.uuid;
      const caption = productAsset.formSection;
      const thumb = '/api/assets/' + productAsset.asset.uuid;
      const album = {
        src: src,
        caption: caption,
        thumb: thumb,
      };

      albums.push(album);
    }
    this._lightbox.open(albums, 0);
  }

  openProjectPlacementLightbox(projectPlacement: ProjectPlacement) {
    let albums = [];
    for (let productAsset of projectPlacement.projectPlacementAssets) {
      if (productAsset.archived) {
        continue;
      }
      const src = '/api/assets/' + productAsset.asset.uuid;
      const caption = productAsset.formSection;
      const thumb = '/api/assets/' + productAsset.asset.uuid;
      const album = {
        src: src,
        caption: caption,
        thumb: thumb,
      };

      albums.push(album);
    }
    this._lightbox.open(albums, 0);
  }

  openMostRecentAdjustmentPhotosLightbox(subProject: SubProject) {
    let albums = [];
    for (let productAsset of subProject.mostRecentlyExecutedProductAssets) {
      if (productAsset.archived) {
        continue;
      }
      const src = '/api/assets/' + productAsset.asset.uuid;
      const caption = productAsset.formSection;
      const thumb = '/api/assets/' + productAsset.asset.uuid;
      const album = {
        src: src,
        caption: caption,
        thumb: thumb,
      };

      albums.push(album);
    }
    this._lightbox.open(albums, 0);
  }

  close(): void {
    // close lightbox programmatically
    this._lightbox.close();
  }

  getPlacerLettres(placer: Employee) {
    let result = '';
    if (placer.user) {
      result = this.getLetters(placer.user);
    }
    return result;
  }

  getPlacerLettresUser(user: User) {
    let result = '';
    if (user) {
      result = this.getLetters(user);
    }
    return result;
  }

  getName(placer: Employee) {
    let result = '';
    if (placer.user) {
      result = result + placer.user.firstName;
      result = result + ' ' + placer.user.lastName;
    }
    return result;
  }

  getNameUser(user: User) {
    let result = '';
    if (user) {
      result = result + user.firstName;
      result = result + ' ' + user.lastName;
    }
    return result;
  }

  doAdjustment(project: Project) {
    this.modalService.confirmDialog(
      'Aanpassing',
      'Bent u zeker dat u een aanpassing wil toevoegen voor project #' +
        project.id +
        '?',
      (answer) => {
        if (answer) {
          this.router.navigateByUrl('/project/' + project.id + '/aanpassing');
        }
      }
    );
  }

  doSoldRented(project: SubProject) {
    this.modalService.confirmDialog(
      'Verkocht/Verhuurd',
      'Bent u zeker dat u een verkocht/verhuurd subproject wil toevoegen voor project #' +
        project.id +
        '?',
      (answer) => {
        if (answer) {
          this.router.navigateByUrl(
            '/project/' + project.id + '/verkocht-verhuurd'
          );
        }
      }
    );
  }

  doRepo(project: SubProject) {
    this.modalService.confirmDialog(
      'Weghalen',
      'Bent u zeker dat u weghalen wil toevoegen voor project #' +
        project.id +
        '?',
      (answer) => {
        if (answer) {
          this.router.navigateByUrl('/project/' + project.id + '/weghalen');
        }
      }
    );
  }

  sendThankYouMail(subProject: SubProject) {
    if (subProject.thankYouMailSent) {
      this.modalService.confirmDialog(
        'Bedankingsmail',
        'Er is al eerder een bedankingsmail verstuurd voor dit project. Bent u zeker dat u dit opnieuw wil doen?',
        (answer) => {
          if (answer != true) {
            return;
          }
          this.openThankYouMailModal(subProject);
        }
      );
    } else {
      this.openThankYouMailModal(subProject);
    }
  }

  openThankYouMailModal(subProject: SubProject) {
    let config = {
      project: subProject.project,
      subProject: subProject,
    };
    this.dialogRef = this.dialog.open(SendThankYouMailComponent, {
      data: config,
    });
    this.addSubscription(this.dialogRef.afterClosed(), (mailSent) => {
      if (mailSent) {
        this.reloadData.emit();
        this.reloadCountChange.emit();
      }
    });
  }

  openModal(subProject: SubProject) {
    let config = {
      project: subProject.project,
      subProject: subProject,
      loadProject: true,
    };
    this.dialogModalRef = this.dialog.open(QuotationSitevisitPendingComponent, {
      data: config,
    });
    this.addSubscription(
      this.dialogModalRef.afterClosed(),
      (project: Project) => {
        if (project) {
          this.loading = true;
          this.addSubscription(
            this.requestService.put(project, '/projects'),
            () => {
              this.reloadData.emit();
              this.reloadCountChange.emit();
            },
            () => {
              this.loading = false;
            }
          );
        }
      }
    );
  }

  openNotificationMailModal(subProject: SubProject) {
    const config = {
      userOptions: ProjectHelper.getInvolvedSubprojectUsers(subProject).filter(
        (u) => u.email != null && u.email.toString() !== ''
      ),
      project: subProject.project,
      subProjectId: subProject.id,
      selectAll: false,
      showQuotationAddress: false,
      performSend: true,
    };
    this.dialog.open(NotificationMailComponent, { data: config });
  }

  getEarliestApprovalDate(subproject: SubProject, project: Project) {
    let toReturn = null;
    for (let p of project.products) {
      if (
        p.approvalDate != null &&
        (toReturn == null || p.approvalDate < toReturn)
      ) {
        toReturn = p.approvalDate;
      }
    }
    return toReturn;
  }

  getDesignDate(project: SubProject) {
    let result = null;
    if (project.currentDesignASAP) {
      return 'ASAP';
    }
    if (project.currentDesignDate) {
      result = project.currentDesignDate;
    }
    if (result != null) {
      return this.formatDate(result);
    } else {
      return '-';
    }
  }

  getSiteVisitDate(project: SubProject) {
    if (project.currentSiteVisitDate != null) {
      return this.formatDate(project.currentSiteVisitDate);
    } else {
      return '-';
    }
  }

  getApprovedOnDate(subproject: SubProject, project: Project) {
    let result = this.getEarliestApprovalDate(subproject, project);
    if (result != null) {
      return this.formatDate(result);
    }
  }

  findEarliestProductPlacement(subproject: SubProject, project: Project) {
    let toReturn = null;
    for (let i = 0; i < project.products.length; i++) {
      let productPlacement = project.products[i].productPlacement;
      if (productPlacement != null) {
        if (
          !productPlacement.placeASAP &&
          productPlacement.actualPlacementDate != null &&
          (toReturn == null || productPlacement.actualPlacementDate < toReturn)
        ) {
          toReturn = productPlacement.actualPlacementDate;
        }
      }
    }
    return toReturn;
  }

  getLetters(user: User) {
    let result = '';
    if (user) {
      result = result + user.firstName[0];
      result = result + user.lastName[0];
    }
    return result;
  }

  getStatusClass(project: SubProject) {
    if (project.displayStatus != null) {
      let toReturn = project.displayStatus
        .toLowerCase()
        .replace(/\s\d+/g, '')
        .replace(/[\s\/]/g, '-');
      toReturn = toReturn.replace('_', ' ');
      return toReturn;
    }
    return 'niet gegeven';
  }

  getCurrentRequestDate(project: SubProject) {
    return ProjectHelper.getCurrentRequestDate(project);
  }

  getCurrentPrintDate(project: SubProject) {
    return ProjectHelper.getCurrentPrintDate(project);
  }

  getCurrentFinishDate(project: SubProject) {
    return ProjectHelper.getCurrentFinishDate(project);
  }

  getCurrentCreatedAt(project: SubProject) {
    return ProjectHelper.getCurrentCreatedAt(project);
  }

  getCurrentConfirmedPlacementDate(project: SubProject) {
    return ProjectHelper.getCurrentConfirmedPlacementDate(project);
  }

  getFormattedDate(date: Date) {
    return date == null ? '__/__' : DateHelper.formatDate(date, 'dd/MM');
  }

  private getPendingBackgroundClass(
    finished: boolean,
    deadline: Date,
    required: boolean
  ): string {
    if (finished) {
      return 'finished';
    }
    if (deadline != null) {
      const deadlineMoment = moment(deadline);
      if (deadlineMoment.isBefore(this.momentToday, 'day')) {
        return 'deadline-passed';
      }
      if (deadlineMoment.isSame(this.momentToday, 'day')) {
        return 'deadline-today';
      }
    }

    if (required === true) {
      return 'neccessary';
    } else if (required === false) {
      return 'unneccessary';
    } else {
      return 'unselected';
    }
  }

  getQuotationBackgroundClass(subProject: SubProject): string {
    return this.getPendingBackgroundClass(
      subProject.quotation ? subProject.quotation.approved : false,
      null, //Don't send date along since the date being shown is not a deadline
      subProject.needsQuotation
    );
  }

  getDesignBackgroundClassForProduct(product: Product): string {
    return this.getPendingBackgroundClass(
      product.designFinished,
      product.designByDate,
      product.needsDesign
    );
  }

  getPrintJobBackgroundClassForProduct(product: Product): string {
    return this.getPendingBackgroundClass(
      product.printWorkReady,
      product.printworkByDate,
      product.needPrintwork
    );
  }

  getFinishingBackgroundClassForProduct(product: Product): string {
    return this.getPendingBackgroundClass(
      product.finishReady,
      product.finishByDate,
      product.needFinish
    );
  }

  getPlacementBackgroundClassForProduct(
    subProject: SubProject,
    product: Product
  ): string {
    return this.getPendingBackgroundClass(
      subProject.withPlacement === false
        ? false
        : product.productPlacement
        ? product.productPlacement.executionComplete
        : false,
      subProject.withPlacement === false
        ? null
        : product.productPlacement
        ? product.productPlacement.actualPlacementDate
        : null,
      subProject.withPlacement
    );
  }

  getDesignBackgroundClass(project: Adjustment): string {
    return this.getPendingBackgroundClass(
      project.designFinished,
      project.currentDesignDate,
      project.type !== 'Repo' && project.needsDesign
    );
  }

  getPrintJobBackgroundClass(project: Adjustment): string {
    return this.getPendingBackgroundClass(
      project.printWorkReady,
      project.currentPrintDate,
      project.type !== 'Repo' && project.needPrintwork
    );
  }

  getFinishingBackgroundClass(project: Adjustment): string {
    return this.getPendingBackgroundClass(
      project.finishReady,
      project.currentFinishDate,
      project.type !== 'Repo' && project.needFinish
    );
  }

  getPlacementBackgroundClass(project: Adjustment): string {
    return this.getPendingBackgroundClass(
      project.withPlacement === false
        ? false
        : project.projectPlacement
        ? project.projectPlacement.placementDone
        : false,
      project.withPlacement === false
        ? null
        : project.currentConfirmedPlacementDate,
      project.withPlacement
    );
  }

  getBadgeIcon(
    finished: boolean,
    approved: boolean,
    sent: boolean,
    locationVerified: boolean,
    backgroundClass: string
  ): string {
    let toReturn: any = {
      borderColor: this.getBadgeBorderColor(backgroundClass),
    };
    if (locationVerified === true) {
      toReturn.icon = 'check-black';
      toReturn.locationVerification = true;
    } else if (locationVerified === false) {
      toReturn.icon = 'exclamation';
      toReturn.locationVerification = true;
    } else if (finished) {
      toReturn.icon = 'double-check-black';
    } else if (!finished && approved) {
      toReturn.icon = 'check-black';
    } else if (!finished && !approved && sent) {
      toReturn.icon = 'send-black';
    } else {
      toReturn.icon = '';
    }
    toReturn.transformClass =
      toReturn.icon === '' ? null : 'transform-' + toReturn.icon;
    return toReturn;
  }

  private getBadgeBorderColor(backgroundClass: string): string {
    switch (backgroundClass) {
      case 'finished':
        return '#62D84C';
      case 'deadline-passed':
        return '#ff5555';
      case 'deadline-today':
        return '#FFA831';
      case 'neccessary':
        return '#F2DE47';
      case 'unneccessary':
        return '#F0F0F0';
      case 'unselected':
      default:
        return '#DCDCDC';
    }
  }

  getBadgeTooltip(finished: boolean, approved: boolean, sent: boolean): string {
    if (finished) {
      return 'Afgewerkt';
    }
    if (!finished && approved) {
      return 'Goedgekeurd';
    }
    if (!finished && !approved && sent) {
      return 'Verzonden';
    }
    return '';
  }
  getFilteredProductAssets(productAssets: ProductAsset[]): ProductAsset[] {
    return productAssets.filter((p) => {
      switch (p.formSection) {
        case 'execution':
        case 'adjustmentPlacementSuccess':
          return true;
        default:
          return false;
      }
    });
  }
  getQuotationDate(subProject: SubProject): Date {
    if (subProject.quotation && subProject.quotation.approved) {
      return subProject.quotation.approvalRegistration.date;
    } else if (subProject.quotation && subProject.quotation.sentRegistration) {
      return subProject.quotation.sentRegistration.date;
    } else {
      return null;
    }
  }

  getFirst<T>(list: T[]): T {
    if (!list) {
      return null;
    }
    if (list.length > 0) {
      return list[0];
    }
    return null;
  }

  getLast<T>(list: T[]): T {
    if (!list) {
      return null;
    }
    if (list.length === 0) {
      return null;
    }
    return list[list.length - 1];
  }

  getConfirmedDate(product: Product) {
    return ProductHelper.getConfirmedDate(product);
  }

  printQuotationApprovedDate(subProject: SubProject) {
    return subProject.quotation && subProject.quotation.approvalRegistration
      ? DateHelper.formatDate(subProject.quotation.approvalRegistration.date)
      : '-';
  }

  printQuotationDisapprovedDate(subProject: SubProject) {
    return subProject.quotation && subProject.quotation.disapprovalRegistration
      ? DateHelper.formatDate(subProject.quotation.disapprovalRegistration.date)
      : '-';
  }

  shortenText(text: string) {
    return StringHelper.shortenText(text, 30);
  }

  getPendingContainerClass(first: boolean, last: boolean) {
    if (first && last) {
      return 'pending-container';
    }
    if (!first && !last) {
      return 'pending-container-middle';
    }
    if (first) {
      return 'pending-container-first';
    }
    return 'pending-container-last';
  }

  public getPageTitle(): string {
    return '';
  }

  protected getTableUrl(): string {
    return (
      '/subprojects/' +
      this.getStatusFilter() +
      `/${this.filterOutIPBoardProjects()}`
    );
  }

  protected getLocalStorageKey(): string {
    return '';
  }

  protected getStatusFilter(): string {
    return '';
  }

  protected filterOutIPBoardProjects(): boolean {
    return true;
  }

  public getDefaultSort() {
    return 'project_id';
  }

  public getDefaultSortDirection() {
    return 'asc';
  }

  protected prepareCurrentConfirmedPlacementDateLabel() {
    this.currentConfirmedPlacementDateLabel = 'Plaatsing';
  }

  protected generateTypeCriteriumParam() {
    return this.productTypeCriteriumService.generateTypeCriteriumParam();
  }

  public showFromOldSystemButton() {
    return true;
  }

  nonArchivedImages(product: Product) {
    return ProductHelper.nonArchivedImages(product);
  }

  public showImportant(subproject: SubProject) {
    return false;
  }

  public getRouterLinkNew() {
    return '/project/nieuw/0';
  }

  public getRouterLinkCreateOldSystemProject() {
    return '/create-old-system-project';
  }

  public getRouterLinkOpen(isIpBoardProject = false): string {
    return isIpBoardProject ? '/job' : '/project';
  }

  public openProject(subProject: SubProject) {
    if (this.getLocalStorageKey() === 'VerifyLocationProjectsComponent') {
      this.scrollTopService.setScrollTop(GeneralHelper.getScrollTop());
      const config = {
        projectId: subProject.project == null ? null : subProject.project.id,
        subProjectId: subProject.id,
      };
      this.locationVerificationDialogRef = this.dialog.open(
        LocationVerificationDialogComponent,
        {
          data: config,
        }
      );
      this.addSubscription(
        this.locationVerificationDialogRef.afterClosed(),
        (b) => {
          if (b) {
            this.reloadData.emit();
            this.reloadCountChange.emit();
          }
          this.scrollTopService.setScrollTop(null);
        }
      );
    } else {
      const routerCommands = [
        this.getRouterLinkOpen(
          ProjectHelper.isIPBoardProject(subProject.project)
        ),
        subProject.project == null ? null : subProject.project.id,
        subProject.id,
      ];
      this.addExtraRouterCommands(subProject, routerCommands);
      this.router.navigate(routerCommands);
    }
  }

  protected addExtraRouterCommands(
    subProject: SubProject,
    commands: any[]
  ): void {}

  navigateTab(subProjectId: number, projectId: number, status: String) {
    switch (status) {
      case 'Aanpassing':
        this.router.navigate(['project', subProjectId, projectId], {
          queryParams: { adjustment: true },
        });
        break;
      case 'Verkocht/Verhuurd':
        this.router.navigate(['project', subProjectId, projectId], {
          queryParams: { soldRented: true },
        });
        break;
      case 'Afhaling':
        this.router.navigate(['project', subProjectId, projectId], {
          queryParams: { repo: true },
        });
        break;
      default:
        return null;
    }
  }

  getStatusString(row) {
    return ProjectHelper.getTypeStatusString(row, row.project);
  }

  getType(row) {
    return ProjectHelper.getType(row, row.project);
  }

  isBaseProject(project: SubProject) {
    return project.type === 'BaseProject';
  }

  requestAdjustment(project: Project) {
    this.router.navigateByUrl('/client-project/' + project.id + '/aanpassing');
  }

  requestSoldRented(project: Project) {
    this.router.navigateByUrl(
      '/client-project/' + project.id + '/verkocht-verhuurd'
    );
  }

  requestRepo(project: Project) {
    this.router.navigateByUrl('/client-project/' + project.id + '/weghalen');
  }

  protected preProcessProjects(projects: SubProject[]): void {
    if (projects == null) {
      return;
    }
    projects.forEach((p) => {
      if (p.project != null) {
        p.project.involvedCompanies = ProjectHelper.getDtoInvolvedCompanies(
          p.project
        );
      }
    });
  }

  trackById(index: number, obj: any): number {
    return GeneralHelper.trackById(index, obj);
  }

  generatePlacementSticker(row: SubProject) {
    this.loading = true;
    this.cd.markForCheck();
    this.addSubscription(
      this.requestService.post(
        {},
        'subprojects/generatePlacementSticker/' + row.id
      ),
      (res) => {
        if (res.success === false) {
          this.snackService.showError(res.message);
        } else {
          GeneralHelper.downloadAsset(<Asset>res);
        }
        this.loading = false;
        this.cd.markForCheck();
      },
      (err) => {
        this.snackService.showError(err);
        this.loading = false;
        this.cd.markForCheck();
      }
    );
  }

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) {
      return;
    }
    const assignContainer = document.getElementsByClassName('assign-container');
    if (assignContainer.length > 0) {
      const clickedInside = assignContainer.item(0).contains(targetElement);
      const cdkContainer = document.getElementsByClassName(
        'cdk-overlay-container'
      );
      const clickCdk =
        cdkContainer.length > 0
          ? cdkContainer.item(0).contains(targetElement)
          : false;

      const classArr = [
        'btn--assign',
        'icon--assign',
        'mat-calendar-body',
        'mat-calendar-body-cell-content',
      ];
      const targetClassArr = [].slice.apply(targetElement.classList);
      const hasClass = targetClassArr.some((c) => classArr.includes(c));
      if (!clickedInside && !clickCdk && !hasClass) {
        this.openPlanningShortcut();
      }
    }
  }

  openPlanningShortcut(subProject?: SubProject, reload: boolean = false) {
    if (subProject && subProject.id != this.assignPlanningId) {
      this.assignPlanningId = subProject.id;
      this.assignOpen = true;
    } else {
      this.assignPlanningId = null;
      this.assignOpen = false;
      if (reload) {
        this.rendered.length = 0;
        this.renderedStream.next(this.rendered);
        this.reloadData.next();
      }
    }
  }
}
